/**
 * Browser check functions
 *
 * @module Dates
 * @author Kevin Jones (Fresche Solutions)
 * @date Jan 2021
 */


/**
 * Get a JS Date Object from the given date
 *
 * @param string date
 * @param string format - Optional. Date format
 *
 * @return Date Object
 */
function getDateObject(date, format = 'yyyy-mm-dd') {

    // Determine the date part indexes from the date format
    let formatParts = format.split('-');
    const YEAR_INDEX = (formatParts.indexOf('yyyy') !== -1 ? formatParts.indexOf('yyyy') : formatParts.indexOf('YYYY'));
    const MONTH_INDEX = (formatParts.indexOf('mm') !== -1 ? formatParts.indexOf('mm') : formatParts.indexOf('MM'));
    const DATE_INDEX = (formatParts.indexOf('dd') !== -1 ? formatParts.indexOf('dd') : formatParts.indexOf('DD'));

    // Break the date into date parts and assign to the date object
    let dateObj = new Date();
    let dateParts = date.split('-');
    dateObj.setFullYear( dateParts[YEAR_INDEX] );
    dateObj.setMonth( dateParts[MONTH_INDEX] - 1 );    // Months are zero-relative in JS
    dateObj.setDate( dateParts[DATE_INDEX] );          // Day of the month

    // Set time to midnight so comparisons won't be thrown off by time
    dateObj.setHours(0);
    dateObj.setMinutes(0);
    dateObj.setSeconds(0);
    dateObj.setMilliseconds(1);     // Ensures we're actually on the date

    return dateObj;
};


/**
 * Get a date string from a JS Date object
 *
 * @param Date
 * @return string - date in the format yyyy-mm-dd
 */
function getDateFromDateObject(dateObject) {

    let year = dateObject.getFullYear();

    // Two digit month
    let month = dateObject.getMonth() + 1;
    if (month < 10) month = '0' + month;

    // Two digit date
    let date = dateObject.getDate();
    if (date < 10) date = '0' + date;

    return year + '-' + month + '-' + date;
}



export default {
    namespaced: "true",
    getDateObject,
    getDateFromDateObject,
};
